import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class ContratacoesConcluidasService extends CRUDService{
    constructor() {
        super("solicitacao");
    }

    listarContratacoesConcluidas(filtro) {
        return http.post("/"+this.serviceName+"/concluida", filtro);
    }
}